import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BuscadorPolizasComponent } from '../../../comun/components/buscador-polizas/buscador-polizas.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	standalone: true,
	imports: [
		CommonModule, 
		BuscadorPolizasComponent,
		TranslateModule
	],
	templateUrl: './buscador-polizas.view.html',
	styleUrls: ['./buscador-polizas.view.scss']
})
export class BuscadorPolizasView {}
